import { cva } from "class-variance-authority";

export const alertRootStyle = cva("p-4 border rounded-lg relative flex flex-wrap gap-3 text-sm min-w-[21.5rem]", {
  variants: {
    type: {
      primary: "border-primary-90 bg-primary-99 text-primary-50",
      secondary: "border-neutral-92 bg-neutral-99 text-neutral-40",
      error: "border-error-87 bg-error-96 text-error-50",
      warning: "border-warning-80 bg-warning-98 text-warning-60",
      success: "border-success-90 bg-success-99 text-success-50",
    },
    orientation: {
      horizontal: "flex-row items-center justify-between",
      vertical: "flex-col w-fit max-w-[21.5rem]",
    },
  },
  defaultVariants: {
    type: "primary",
    orientation: "vertical",
  },
});

export const alertBadgeTitleStyle = cva(
  "flex gap-3 w-fit mix-blend-multiply rounded-2xl py-1 pl-1 pr-2.5 font-semibold text-sm items-center",
  {
    variants: {
      type: {
        primary: "bg-primary-96 text-primary-50",
        secondary: "bg-neutral-96 text-neutral-30",
        error: "bg-error-94 text-error-50",
        warning: "bg-warning-98 text-warning-60",
        success: "bg-success-98 text-success-50",
      },
    },
    defaultVariants: {
      type: "primary",
    },
  }
);

export const alertBadgeStyle = cva("px-2.5 pt-0.5 text-sm font-semibold bg-white rounded-2xl", {
  variants: {
    type: {
      primary: "text-primary-50",
      secondary: "text-neutral-30",
      error: "text-error-50",
      warning: "text-warning-60",
      success: "text-success-50",
    },
  },
  defaultVariants: {
    type: "primary",
  },
});

export const alertLayoutStyle = cva("flex", {
  variants: {
    orientation: {
      horizontal: "flex-row items-center",
      vertical: "flex-col w-fit",
    },
  },
  defaultVariants: {
    orientation: "vertical",
  },
});

export const alertActionsStyle = cva("text-sm font-semibold", {
  variants: {
    type: {
      primary: "text-primary-40",
      secondary: "text-neutral-40",
      error: "text-error-40",
      warning: "text-warning-50",
      success: "text-success-40",
    },
  },
  defaultVariants: {
    type: "primary",
  },
});
